'use client';

import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Theme } from '@argo/principles';
import optimizelyClient from '../utilities/optimizelyClient';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import consumerId from '../utilities/myConsumerId';
import { store } from '../stores/store';
import { AnalyticsEngineConfigured } from '../analytics/analyticsEngine';
import { DownloadSelfHostedFonts } from '@argo/utils';
import { isProd } from '../constants/config';

interface ClientAppShellProps { children: React.ReactNode }

const appEnvironment = isProd ? 'prod' : 'nonprod';

export function ClientAppShell({ children }: ClientAppShellProps) {
  return (
    <Theme>
      <OptimizelyProvider optimizely={optimizelyClient} user={{ id: consumerId }}>
        <ReduxProvider store={store}>
          <AnalyticsEngineConfigured />
          {children}
          {/* Self-hosted fonts restored - ensures production font consistency */}
          <DownloadSelfHostedFonts env={appEnvironment} />
        </ReduxProvider>
      </OptimizelyProvider>
    </Theme>
  );
}

export default ClientAppShell;
